import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Popup, Icon } from "semantic-ui-react";

import { itemAccessors, batchStatuses, zoneStatus } from "../../../../utils/constants";

const OrderTableCell = ({ cell, editable, rowId }) => {
  const isListValue = Array.isArray(cell.value);

  return (
    <td
      {...cell.getCellProps()}
      key={`${rowId}-${cell.column.id}`}
      className={classNames("order-table-cell", {
        location: cell.column.id === itemAccessors.location,
        code: cell.column.id === itemAccessors.code,
        description: cell.column.id === itemAccessors.description,

        variance: cell.column.id === itemAccessors.orderVariance,
        "worst-batch-status":
          cell.column.id === itemAccessors.worstBatchStatus,
        "actual-order": cell.column.id === itemAccessors.actualOrder,
        "suggested-order":
          cell.column.id === itemAccessors.suggestedOrder,
        "variance-cell-surplus":
          cell.column.id === itemAccessors.orderVariance &&
          cell.value.delta > 0,
        "variance-cell-deficit":
          cell.column.id === itemAccessors.orderVariance &&
          cell.value.delta < 0,
        "variance-cell-none":
          cell.column.id === itemAccessors.orderVariance &&
          cell.value.delta === 0,
        "disabled-cell":
          !editable &&
          (cell.column.id === itemAccessors.orderVariance ||
            cell.column.id === itemAccessors.actualOrder)
      },
      // Status of materials, expired, expe....
      {
        expired:
          cell.column.id === itemAccessors.worstBatchStatus &&
          cell.value === batchStatuses.expired,
        expiry_this_week:
          cell.column.id === itemAccessors.worstBatchStatus &&
          cell.value === batchStatuses.expiry_this_week,
        expiry_next_week:
          cell.column.id === itemAccessors.worstBatchStatus &&
          cell.value === batchStatuses.expiry_next_week,
        expiry_two_weeks:
          cell.column.id === itemAccessors.worstBatchStatus &&
          cell.value === batchStatuses.expiry_two_weeks,
        expiry_three_weeks:
          cell.column.id === itemAccessors.worstBatchStatus &&
          cell.value === batchStatuses.expiry_three_weeks,
        expiry_three_plus_weeks:
          cell.column.id === itemAccessors.worstBatchStatus &&
          cell.value === batchStatuses.expiry_three_plus_weeks,
      },
      // To paint color of cells or words by on-hand stock zone
      // TODO: to solve this problem maybe is necessary to use columnId
      {
        blue_background: cell.row.values.buffer_zone_color === zoneStatus.blue_zone &&
          (cell.column.id === itemAccessors.onHandStock || cell.column.id === itemAccessors.bufferZoneColor),
        green_background: cell.row.values.buffer_zone_color === zoneStatus.green_zone &&
          (cell.column.id === itemAccessors.onHandStock || cell.column.id === itemAccessors.bufferZoneColor),
        yellow_background: cell.row.values.buffer_zone_color === zoneStatus.yellow_zone &&
          (cell.column.id === itemAccessors.onHandStock || cell.column.id === itemAccessors.bufferZoneColor),
        red_background: cell.row.values.buffer_zone_color === zoneStatus.red_zone &&
          (cell.column.id === itemAccessors.onHandStock || cell.column.id === itemAccessors.bufferZoneColor),
        grey_background: cell.row.values.buffer_zone_color === zoneStatus.grey_zone &&
          (cell.column.id === itemAccessors.onHandStock || cell.column.id === itemAccessors.bufferZoneColor),
        no_zone: cell.row.values.buffer_zone_color === zoneStatus.stock_out &&
          (cell.column.id === itemAccessors.onHandStock || cell.column.id === itemAccessors.bufferZoneColor),
      }

      )}
    >
      {isListValue ? (
        <Popup
          on="hover"
          hoverable
          position="bottom center"
          onClick={(e) => e.stopPropagation()}
          trigger={
            <span className="order-table-cell-list-value">
              {cell.value.length}
              <Icon name="info circle" size="small" />
            </span>
          }
          content={
            <div className="order-table-cell-list-popup">
              {cell.value.map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </div>
          }
        />
      ) : (
        cell.render("Cell")
      )}
    </td>
  );
};

OrderTableCell.propTypes = {
  cell: PropTypes.object,
  editable: PropTypes.bool,
  rowId: PropTypes.string,
};

export default OrderTableCell;
